import { render } from "./AddPointBottomMenu.vue?vue&type=template&id=105415a8&scoped=true"
import script from "./AddPointBottomMenu.vue?vue&type=script&lang=js"
export * from "./AddPointBottomMenu.vue?vue&type=script&lang=js"

import "./AddPointBottomMenu.vue?vue&type=style&index=0&id=105415a8&lang=scss&scoped=true"

import exportComponent from "/home/esesja/domains/app.esesja.mda.pl/public_html/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-105415a8"]])

export default __exports__